import { formatNumber } from '@nemuru-eng/js-api-client';

import { DurationUnit } from '@/components/modules/Metrics/LenderRanking/types/DurationUnit';

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export class DurationMap {
  static toUnit(seconds: number): { value: string; unit: DurationUnit } {
    if (seconds < HOUR) return { value: formatNumber(Math.max(1, seconds / MINUTE), 0), unit: DurationUnit.MINUTES };
    if (seconds < DAY) return { value: formatNumber(seconds / HOUR, 1), unit: DurationUnit.HOURS };
    return { value: formatNumber(seconds / DAY, 1), unit: DurationUnit.DAYS };
  }
}
